/*
  Featured collection carousel (sections/section-collection.liquid).
  Each carousel is set up on its own, using its section's "Products per row" setting.
  It starts at the first product (the newest issue) and stops at the ends instead of
  wrapping round, so the back arrow never jumps to the oldest issues.
*/
(function () {
  function arrow(dir) {
    var path = dir === 'prev' ? 'M26 33L16 22L26 11' : 'M18 33L28 22L18 11';
    var label = dir === 'prev' ? 'Previous' : 'Next';
    return '<button type="button" class="slide-arrow ' + dir + '-arrow" aria-label="' + label + '">' +
      '<svg width="44" height="44" viewBox="0 0 44 44" fill="none" aria-hidden="true" focusable="false">' +
      '<rect width="44" height="44" rx="6" fill="#045D96"/>' +
      '<path d="' + path + '" stroke="#fff" stroke-width="2.5"/>' +
      '</svg></button>';
  }

  function init(scope) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;
    $(scope || document).find('[data-product-slider]').each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) return;
      var count = parseInt($slider.closest('[data-product-count]').attr('data-product-count'), 10) || 3;
      $slider.slick({
        dots: false,
        infinite: false,
        lazyLoad: 'ondemand',
        slidesToShow: count,
        slidesToScroll: 1,
        prevArrow: arrow('prev'),
        nextArrow: arrow('next'),
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: Math.min(count, 3), slidesToScroll: 1 } },
          { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false, dots: true } }
        ]
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: set the carousel up again when its section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var $ = window.jQuery;
    if ($ && $.fn && $.fn.slick) $(e.target).find('[data-product-slider].slick-initialized').slick('unslick');
  });
})();
